// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3720) return "static/chunks/3720-b289776aea7cf02a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"4106":"b9633c63","6266":"010bb10a"}[chunkId] || chunkId) + "." + {"2424":"68e9efa41917d327","4106":"430eae371c711fda","4119":"1ead4363ecb74b97","4879":"9e6d3e1c842cf4a2","5468":"032e49c52c69ef3e","6266":"8f84855642fa55da","9238":"553909f34e3f56d1"}[chunkId] + ".js";
};